import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/Services/RealEstateBrokeragePage/RealEstateBrokeragePage.tsx");
